import { useState } from "react";

const plans = [
  {
    name: "基础版", en: "Basic", badge: null, price: "按需定价", desc: "适合城商行 / 农商行",
    features: [
      { text: "对公业务拓客模块", sub: null },
      { text: "零售业务拓客模块", sub: null },
      { text: "标准客户画像分析", sub: null },
      { text: "区域POI数据接入", sub: null },
      { text: "月度数据更新", sub: null },
    ],
    locked: [
      { text: "抵押贷款辅助系统", sub: null },
      { text: "网点选址优化模型", sub: null },
      { text: "私有化部署", sub: null },
    ],
    cta: "申请方案 / 获取报价",
    highlighted: false,
  },
  {
    name: "专业版", en: "Professional", badge: "最受欢迎", price: "按需定价", desc: "适合股份制银行 / 区域银行",
    features: [
      { text: "对公业务拓客模块", sub: null },
      { text: "零售业务拓客模块", sub: null },
      { text: "深度客户画像分析", sub: "含风险评级" },
      { text: "抵押贷款辅助系统", sub: null },
      { text: "网点选址优化模型", sub: null },
      { text: "实时数据更新", sub: null },
      { text: "API接口对接", sub: "标准接口" },
    ],
    locked: [
      { text: "私有化部署", sub: null },
    ],
    cta: "申请方案 / 获取报价",
    highlighted: true,
  },
  {
    name: "旗舰版", en: "Enterprise", badge: null, price: "定制报价", desc: "适合国有大行 / 全国性机构",
    features: [
      { text: "专业版全部功能", sub: "全量包含" },
      { text: "私有化部署", sub: "数据不出内网" },
      { text: "定制化数据模型", sub: "按业务场景" },
      { text: "全行级API接口", sub: "无限调用" },
      { text: "专属实施团队", sub: "驻场支持" },
      { text: "7×24小时技术保障", sub: null },
      { text: "专属数据安全审计", sub: null },
      { text: "定期业务复盘服务", sub: null },
    ],
    locked: [],
    cta: "申请方案 / 获取报价",
    highlighted: false,
  },
];

const commitments = [
  { icon: "ri-shield-check-line", title: "金融级数据安全", desc: "三级等保认证" },
  { icon: "ri-customer-service-line", title: "24h 咨询响应", desc: "专属顾问服务" },
  { icon: "ri-file-list-3-line", title: "合规数据来源", desc: "合法合规使用" },
  { icon: "ri-rocket-line", title: "快速交付上线", desc: "最快2周部署" },
];

const faqs = [
  { q: "数据安全如何保障？", a: "平台通过国家三级等保认证，全程加密传输，支持私有化部署，数据不出内网，严格遵循金融数据合规要求。" },
  { q: "是否支持与现有系统集成？", a: "支持标准API接口对接，可与主流银行核心系统、CRM系统、信贷管理系统等进行集成，专业版及旗舰版支持深度定制集成。" },
  { q: "数据更新频率是多少？", a: "基础版月度更新，专业版及旗舰版支持实时数据更新，确保金融机构掌握最新市场动态。" },
  { q: "是否有试用方案？", a: "提供30天免费试点方案，可在贵机构真实业务场景中验证平台效果，专业顾问全程陪同。" },
];

export default function FSPricingV2() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      {/* PRICING */}
      <section className="py-20 px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-14">
            <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Pricing</span>
            <h2 className="text-3xl font-bold text-slate-800 mb-3">定价体系</h2>
            <p className="text-slate-500 text-sm max-w-2xl mx-auto">灵活的服务方案，满足不同规模金融机构的数字化转型需求，所有方案均提供专属顾问支持</p>
          </div>

          <div className="grid grid-cols-3 gap-6 max-w-6xl mx-auto">
            {plans.map(plan => (
              <div key={plan.name} className={`relative rounded-2xl p-7 border transition-all ${plan.highlighted ? "bg-gradient-to-b from-cyan-50 to-white border-cyan-200 shadow-lg scale-105" : "bg-white border-slate-200 hover:border-cyan-200"}`}>
                {plan.badge && <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-cyan-600 text-white text-xs font-semibold px-4 py-1 rounded-full">{plan.badge}</div>}
                <h3 className={`font-bold text-lg mb-1 ${plan.highlighted ? "text-slate-800" : "text-slate-800"}`}>{plan.name}</h3>
                <div className={`text-xs mb-3 ${plan.highlighted ? "text-slate-400" : "text-slate-400"}`}>{plan.en}</div>
                <div className="text-2xl font-bold text-slate-800 mb-1">{plan.price}</div>
                <p className="text-xs text-slate-500 mb-5">{plan.desc}</p>
                <ul className="space-y-2.5 mb-4">
                  {plan.features.map(f => (
                    <li key={f.text} className="flex items-center gap-2 text-sm text-slate-600">
                      <i className="ri-check-line text-emerald-500 text-sm flex-shrink-0"></i>
                      <span>{f.text}</span>
                      {f.sub && <span className="text-xs text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">({f.sub})</span>}
                    </li>
                  ))}
                </ul>
                {plan.locked.length > 0 && (
                  <ul className="space-y-2.5 mb-6 pt-4 border-t border-slate-100">
                    {plan.locked.map(f => (
                      <li key={f.text} className="flex items-center gap-2 text-sm text-slate-400">
                        <i className="ri-close-line text-slate-300 text-sm flex-shrink-0"></i>
                        <span>{f.text}</span>
                      </li>
                    ))}
                  </ul>
                )}
                <button className={`w-full py-2.5 rounded-lg text-sm font-semibold transition-all cursor-pointer ${plan.highlighted ? "bg-cyan-600 hover:bg-cyan-700 text-white" : "border border-cyan-600 text-cyan-600 hover:bg-cyan-50"}`}>
                  {plan.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICE COMMITMENT */}
      <section className="py-16 px-8" style={{ background: "#f4f8fb" }}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <span className="text-xs font-semibold text-cyan-600 tracking-widest uppercase mb-2 block">Service Commitment</span>
            <h3 className="text-2xl font-bold text-slate-800">所有方案均包含的服务承诺</h3>
          </div>
          <div className="grid grid-cols-4 gap-6 max-w-4xl mx-auto">
            {commitments.map(c => (
              <div key={c.title} className="bg-white rounded-xl px-5 py-5 border border-slate-100 text-center">
                <div className="w-12 h-12 rounded-xl bg-cyan-50 flex items-center justify-center mx-auto mb-3">
                  <i className={`${c.icon} text-cyan-600 text-xl`}></i>
                </div>
                <div className="text-slate-800 font-semibold text-sm">{c.title}</div>
                <div className="text-slate-400 text-xs mt-0.5">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-8 bg-white">
        <div className="max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-slate-800 text-center mb-8">常见问题</h3>
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={faq.q} className="border border-slate-200 rounded-xl overflow-hidden">
                <button onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  className="w-full flex items-center justify-between px-5 py-4 text-sm text-slate-700 font-medium hover:bg-slate-50 transition-colors cursor-pointer">
                  {faq.q}
                  <i className={`ri-arrow-down-s-line text-slate-400 transition-transform ${openFaq === i ? "rotate-180" : ""}`}></i>
                </button>
                {openFaq === i && (
                  <div className="px-5 pb-4 text-sm text-slate-500 leading-relaxed">{faq.a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-10 px-8" style={{ background: "#0a1e3a" }}>
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-2">
              <i className="ri-funds-line text-cyan-300 text-xl"></i>
              <span className="text-white font-bold text-base">空天数源数据服务平台</span>
            </div>
            <div className="flex items-center gap-6">
              {["产品服务", "API接口", "解决方案", "关于我们"].map(item => (
                <button key={item} className="text-blue-200/70 hover:text-white text-sm cursor-pointer transition-colors">{item}</button>
              ))}
            </div>
          </div>
          <div className="pt-6 border-t border-white/10 text-center text-blue-200/40 text-xs">
            © 2026 空天数源数据服务平台. 保留所有权利.
          </div>
        </div>
      </footer>
    </>
  );
}
